import { LogEventExternalProps } from './index';
import { useGlobalStore } from '@/stores/global';
import { getQueryParams } from '@/utils/common';
const { token, bgwheadInfo, chainObj, curTaskId } = useGlobalStore.getState();
export const pageInfoList = [
  {
    path: '/newer',
    event_tracking: 'bk_h5_newuser_mission_home_page',
    event_tracking_id: 'b9438',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking_ext_fields: [
      'address',
      'channel_af',
      'system_language',
      'wallet_tag',
      'wallet_type',
    ],
    event_tracking_ext: {
      address: chainObj?.eth ?? '',
      system_language: bgwheadInfo.LANGUAGE,
    },
  },
  {
    path: '/newer/question',
    event_tracking_id: 'b9442',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_Question_answering_activity_page',
    event_tracking_ext_fields: [
      'id',
      'task_name',
      'address',
      'channel_af',
      'system_language',
      'wallet_id',
      'wallet_tag',
    ],
    event_tracking_ext: {
      id: curTaskId,
      address: chainObj?.eth ?? '',
      system_language: bgwheadInfo.LANGUAGE,
    },
  },
  {
    path: '/bwbWelfareCenter',
    event_tracking: 'bk_h5_BWB_center_page',
    event_tracking_id: 'b9660',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking_ext: {
      address: chainObj?.eth ?? '',
      channel_af: 'bwbWelfareCenter',
      system_language: bgwheadInfo.LANGUAGE,
      type: '',
      wallet_id: token,
      wallet_tag: 0,
      wallet_type: 0,
    },
  },
];

export const PAGE_INFO_FIELDS = [
  'path',
  'event_tracking',
  'event_tracking_id',
  'business1',
  'business2',
  'event_tracking_ext',
];

declare global {
  interface PageEvents {
    b9438: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9438';
    };
    b9442: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9442';
    };
    b9660: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9660';
    };
  }
  interface ClickEvents {
    b9233: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9233';
    };
    b6429: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b6429';
    };
    b9439: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9439';
    };
    b9441: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9441';
    };
    b9662: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9662';
    };
    b10706: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b10706';
    };
    b10705: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b10705';
    };
  }
  interface ExposeEvents {
    b6428: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b6428';
    };
    b9440: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9440';
    };
    b9676: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9676';
    };
    b9661: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b9661';
    };
    b10704: Exclude<LogEventExternalProps, 'event_tracking_id'> & {
      event_tracking_id: 'b10704';
    };
  }
}

export const ClickEvents: ClickEvents = {
  b9233: {
    event_tracking_id: 'b9233',
    business1: 'wallet',
    business2: 'bk_base',
    event_tracking: 'bk_h5_claim_bot:_click',
  },
  b6429: {
    event_tracking_id: 'b6429',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_top_app_download_guide:_click',
  },
  b9439: {
    event_tracking_id: 'b9439',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_newuser_mission_home_page:withdraw_click',
  },
  b9441: {
    event_tracking_id: 'b9441',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_newuser_mission_home_page:task_click',
    event_tracking_ext: {
      activityId: '',
      activity_type: '',
      address: token,
      channel_af: '',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_tag: '',
      wallet_type: '',
    },
  },
  b9662: {
    event_tracking_id: 'b9662',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_BWB_center:_click',
  },
  b10706: {
    event_tracking_id: 'b10706',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_BWB_Swapto_BGB:Error_click',
  },
  b10705: {
    event_tracking_id: 'b10705',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_newuser_mission_home_page:getready_click',
    event_tracking_ext: {
      activityId: '',
      activity_type: '',
      address: token,
      channel_af: 'newer',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_tag: '',
      wallet_type: '',
    },
  },
};

export const ExposeEvents: ExposeEvents = {
  b6428: {
    event_tracking_id: 'b6428',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_top_app_download_guide:_exposure',
    event_tracking_ext: {},
  },
  b9440: {
    event_tracking_id: 'b9440',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_newuser_mission_home_page:task_exposure',
    event_tracking_ext: {
      address: token,
      channel_af: 'newer_WelcomeWeb3Drawer',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_tag: '',
      wallet_type: '',
    },
    merge: true,
  },
  b9676: {
    event_tracking_id: 'b9676',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_Question_answering_activity:_exposure',
    event_tracking_ext: {},
    merge: true,
  },
  b9661: {
    event_tracking_id: 'b9661',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_BWB_center:_exposure',
    event_tracking_ext: {},
  },
  b10704: {
    event_tracking_id: 'b10704',
    business1: 'marketing_growth',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_newuser_mission_home_page:getready_exposure',
    event_tracking_ext: {
      activityId: '',
      activity_type: '',
      address: token,
      channel_af: 'newer_WelcomeWeb3Drawer',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_tag: '',
      wallet_type: '',
    },
  },
};
export const PageEvents: PageEvents = {
  b9438: {
    path: '/newer',
    event_tracking: 'bk_h5_newuser_mission_home_page',
    event_tracking_id: 'b9438',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking_ext: {
      address: token,
      channel_af: '',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_tag: '',
      wallet_type: '',
    },
  },
  b9442: {
    path: '/newer/question',
    event_tracking_id: 'b9442',
    business1: 'growth',
    business2: 'marketing_growth',
    event_tracking: 'bk_h5_Question_answering_activity_page',
    event_tracking_ext: {
      id: '',
      task_name: '',
      address: token,
      channel_af: '',
      system_language: bgwheadInfo?.LANGUAGE ?? 'en',
      wallet_id: '',
      wallet_tag: '',
    },
  },
  b9660: {
    path: '/bwbWelfareCenter',
    event_tracking_id: 'b9660',
    business1: 'wallet',
    business2: 'bk_growth',
    event_tracking: 'bk_h5_BWB_center_page',
    event_tracking_ext() {
      const { source } = getQueryParams(window.location.href);
      return {
        address: chainObj?.eth ?? '',
        channel_af: source || 'bwbWelfareCenter',
        system_language: bgwheadInfo?.LANGUAGE ?? 'en',
        type: '',
        wallet_id: token,
        wallet_tag: 0,
        wallet_type: 0,
      };
    },
  },
};
